<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <EtablissementSection />
  <AdresseEmployeur />
  <DetailsSection />
</template>

<script setup lang="ts">
  import AdresseEmployeur from './sections/adresseEmployeur/AdresseEmployeurSection.vue'
  import EtablissementSection from './sections/etablissement/EtablissementSection.vue'
  import DetailsSection from './sections/detailsComplementaires/DetailsSection.vue';
</script>
